import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_uti_biologicalSex',
    label: 'What is your biological sex?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Female', key: 'female' },
        { value: 'Male', key: 'male' }
      ]
    }
  },
  {
    field: 'zalud_uti_redFlagSymptoms',
    label:
      'Do you currently have any of the following symptoms? Select all that apply:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Fever or chills', key: 'fever_chills' },
        {
          value: 'Lower back or flank pain (kidney area)',
          key: 'flank_pain'
        },
        { value: 'Nausea or vomiting', key: 'nausea_vomiting' },
        {
          value:
            "Unable to urinate or feeling like your bladder won't empty",
          key: 'urinary_inability'
        },
        { value: 'I feel very ill', key: 'feel_very_ill' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_uti_frequency',
    label: 'How often have you had urinary tract infections?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'First time or very rarely', key: 'first_time_or_rarely' },
        {
          value: '2 or more in the last 6 months',
          key: 'two_or_more_six_months'
        },
        {
          value: '3 or more in the past year',
          key: 'three_or_more_past_year'
        }
      ]
    }
  },
  {
    field: 'zalud_uti_urologicalConditions',
    label:
      'Do you have any of the following conditions? Select all that apply:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value:
            'Known urological abnormality (single kidney, neurogenic bladder, structural malformations)',
          key: 'urological_abnormality'
        },
        {
          value: 'Permanent urinary catheter or self-catheterization',
          key: 'catheter'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_uti_painBurning',
    label: 'Do you have pain or burning with urination?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_uti_frequentUrination',
    label: 'Are you urinating more frequently than usual?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_uti_urgency',
    label:
      'Do you feel a sudden, strong urge to urinate that is difficult to control?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_uti_lowerAbdominalPain',
    label:
      'Do you have pain or pressure in your lower abdomen, just above the pubic bone?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: "I'm not sure", key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_uti_bloodInUrine',
    label: 'Have you noticed blood in your urine?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_uti_nocturia',
    label: 'Are you waking up at night to urinate?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_uti_symptomDuration',
    label: 'How many days have you had these symptoms?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 1 day', key: 'less_than_1_day' },
        { value: '1–3 days', key: 'one_to_three_days' },
        { value: '4–7 days', key: 'four_to_seven_days' },
        { value: 'More than 7 days', key: 'more_than_seven_days' }
      ]
    }
  },
  {
    field: 'zalud_uti_symptomIntensity',
    label:
      'Symptom intensity (scale of 1 to 10, where 1 = barely noticeable and 10 = very severe):',
    type: 'info',
    answer: {
      type: 'number',
      name: 'zalud_uti_symptomIntensity',
      min: 1,
      max: 10,
      placeholder: 'Enter a number from 1 to 10'
    }
  },
  {
    field: 'zalud_uti_vaginalSymptoms',
    label:
      'Do you have any unusual vaginal discharge or vaginal irritation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not applicable', key: 'not_applicable' }
      ]
    }
  },
  {
    field: 'zalud_uti_medicalConditions',
    label:
      'Do you have any of the following medical conditions? Select all that apply:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Diabetes', key: 'diabetes' },
        { value: 'Kidney disease', key: 'kidney_disease' },
        { value: 'None', key: 'none', uncheckOthers: true },
        {
          value: 'Other',
          key: 'other',
          answer: {
            type: 'text',
            name: 'zalud_uti_medicalConditionsOther',
            placeholder: 'Please specify',
            rows: 2
          }
        }
      ]
    }
  },
  {
    field: 'zalud_uti_antibioticAllergies',
    label: 'Are you allergic to any antibiotics, if yes, which ones?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'zalud_uti_antibioticAllergies',
      rows: 4,
      placeholder: 'List any antibiotic allergies, or write None'
    }
  },
  {
    field: 'zalud_uti_recentAntibiotics',
    label: 'Have you taken antibiotics in the last 3 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No', key: 'no' },
        { value: 'Yes', key: 'yes' },
        { value: "I don't remember", key: 'dont_remember' }
      ]
    }
  },
  {
    field: 'zalud_uti_recentAntibioticsWhich',
    label: 'Which antibiotics have you taken in the last 3 months?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'zalud_uti_recentAntibioticsWhich',
      rows: 4,
      placeholder: 'Please list the antibiotics'
    }
  },
  {
    field: 'zalud_uti_negativeCulture',
    label:
      'Have you ever been told that your urine culture came back negative even though you had UTI symptoms?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No', key: 'no' },
        {
          value: "I've never had a culture done",
          key: 'never_had_culture'
        },
        {
          value: 'Yes, my culture was negative despite symptoms',
          key: 'yes_negative'
        }
      ]
    }
  },
  {
    field: 'zalud_uti_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_uti_additionalComments'
    }
  },
  {
    field: 'zalud_uti_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_uti_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_uti_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludUtiTreatmentQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
